/*
 * Компонент AdminWorks — управление уведомлением о технических работах
 *
 * Основные функции:
 * - Загрузка актуальных настроек уведомления с сервера при открытии
 * - Редактирование текста объявления о технических работах
 * - Включение/выключение глобального отображения объявления
 * - Сохранение изменений через SettingsEndpoint
 */
<script setup lang="ts">
// Хуки жизненного цикла и реактивность Vue
import { ref, onMounted } from 'vue'
// Определение размера экрана — для динамического padding
import { useDisplay } from 'vuetify'
// Утилита определения Telegram-контекста
import { isTelegram } from '@/utils/isTelegram'
// Компонент заголовка секции
import SectionHeader from '@/components/SectionHeader.vue'
// Стор настроек — загрузка и обновление настроек приложения
import { useSettingsStore } from '@/modules/settings/store/settingsStore'

// Инициализация стора настроек
const settingsStore = useSettingsStore()
// Определение мобильного экрана для динамического padding
const { mobile } = useDisplay()

// Локальное состояние флага отображения глобального объявления
const showGlobalNotification = ref(false)
// Локальное состояние текста объявления о тех. работах
const notificationText = ref('')

// Загрузка актуальных настроек с сервера и синхронизация локального состояния
onMounted(async () => {
  await settingsStore.getSettings()
  showGlobalNotification.value = settingsStore.showGlobalNotification
  notificationText.value = settingsStore.notificationText
})

/**
 * Сохраняет изменения настроек уведомления на сервер
 *
 * Основные действия:
 * - Отправляет текущие значения showGlobalNotification и notificationText
 * - Вызывает settingsStore.updateSettings для обновления через gRPC
 */
const saveChanges = async () => {
  await settingsStore.updateSettings({
    showGlobalNotification: showGlobalNotification.value,
    notificationText: notificationText.value,
  })
}
</script>

<template>
  <div class="d-flex flex-column ga-4 pt-4" :class="{ 'pa-4': isTelegram() || mobile }">
    <header>
      <section-header />
    </header>

    <v-textarea
      v-model="notificationText"
      label="Текст объявления"
      variant="outlined"
      rows="4"
      hide-details
    />

    <v-checkbox
      v-model="showGlobalNotification"
      label="Показать объявление"
      color="primary"
      hide-details
    />

    <v-btn
      color="primary"
      variant="flat"
      block
      @click="saveChanges"
    >
      Сохранить изменения
    </v-btn>
  </div>
</template>

<style scoped></style>
